// src/Components/Analysis/SidebarMenu.js
import React from "react";
import { Layout, Menu, Spin } from "@arco-design/web-react";
import { StatusIcon, PlatformIcon } from './AnalysisComponents';
import { IconCheckCircle, IconPlayCircle } from '@arco-design/web-react/icon';
const Sider = Layout.Sider;

/**
 * 任务菜单组件
 * @param {Array} tasks 任务列表
 * @param {boolean} loading 是否加载中
 * @param {string|number|null} selectedTaskId 当前选中的任务ID
 * @param {function} onTaskSelect 任务点击回调
 */
function TaskMenu({ 
  tasks = [], 
  loading = false,
  batchLoading = false,
  selectedTaskId = null,
  onTaskSelect = () => {},
  pageType = 'analysis' // 新增：页面类型，默认为analysis
}) {
  if (loading) {
    return (
      <div style={{ padding: '32px 0', textAlign: 'center' }}>
        <Spin tip="加载中..." />
      </div>
    );
  }

  const getStatus = (task) => {
    // 根据页面类型决定使用哪种状态
    if (pageType === 'privateCustomer') {
      // PrivateCustomer页面：使用market_state
      if (task.market_state === 'finish') {
        return 'success'; // 绿色 - 已私信
      } else if (task.market_state === 'processing') {
        return 'processing'; // 黄色 - 私信中
      } else if (task.market_state === 'initial') {
        return 'pending'; // 灰色 - 未私信
      }
    } else {
      // Analysis页面：使用analysis_state
      if (task.analysis_state === 'finish') {
        return 'success'; // 绿色
      } else if (task.analysis_state === 'running') {
        return 'processing'; // 黄色
      } else if (task.analysis_state === 'initial') {
        return 'pending'; // 灰色
      }
    }
    return 'info'; // 兜底
  };

  // 处理任务点击事件
  const handleTaskClick = (taskId) => {
    onTaskSelect(taskId);
  };

  return (
    <div>
      {batchLoading && (
        <div style={{ 
          padding: '8px 16px', 
          fontSize: '12px', 
          color: '#1890ff',
          backgroundColor: '#f0f9ff',
          borderLeft: '3px solid #1890ff',
          marginBottom: '8px'
        }}>
          正在分批加载任务数据...
        </div>
      )}
      <Menu
        style={{
          maxHeight: 'calc(100vh - 200px)',
          scrollbarWidth: 'none',
          msOverflowStyle: 'none'
        }}
        selectedKeys={selectedTaskId ? [selectedTaskId.toString()] : []}
      >
        {tasks.length === 0 ? (
          <Menu.Item key="empty" style={{ color: '#999', textAlign: 'center' }}>
            暂无任务
          </Menu.Item>
        ) : (
          tasks.map((item) => {
          const taskId = item.task_id;
          return (
            <Menu.Item 
              key={taskId} 
              style={{ 
                padding: '6px 16px',
                backgroundColor: selectedTaskId === taskId ? '#e6f7ff' : 'transparent',
                borderRight: selectedTaskId === taskId ? '3px solid #1890ff' : 'none'
              }}
              onClick={() => handleTaskClick(taskId)}
            ><div style={{
              display: 'flex',
              alignItems: 'center',
              height: 32,
              minHeight: 32,
            }}>
              {/* 状态图标 */}
              <span style={{
                width: 22,
                height: 22,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                marginRight: 6,
              }}>
                <StatusIcon 
                  status={getStatus(item)} 
                  progress={item.progress || 0} 
                />
              </span>
              {/* 任务关键词 */}
              <span
                style={{
                  flex: 1,
                  fontSize: 14,
                  height: 20,
                  display: 'flex',
                  alignItems: 'center',
                  fontWeight: selectedTaskId === taskId ? 'bold' : 'normal',
                  color: selectedTaskId === taskId ? '#1890ff' : '#333',
                  minWidth: 0,
                  overflow: 'hidden',
                  textOverflow: 'ellipsis',
                  whiteSpace: 'nowrap',
                }}
                title={item.keyword}
              >
                {item.keyword}
              </span>
              {/* 平台logo */}
              <span style={{
                width: 22,
                height: 22,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                marginLeft: 6,
              }}>
                <PlatformIcon platform={item.platform} style={{ width: 20, height: 20, display: 'block' }} />
                </span>
              </div>
            </Menu.Item>
          );
        })
      )}
      </Menu>
    </div>
  );
}

const SidebarMenu = ({ tasks, loading, batchLoading = false,
  selectedTaskId = null,
  onTaskSelect = () => {},
  pageType = 'analysis' // 新增：页面类型参数
}) => (
  <Sider
    width={260}
    style={{
      height: '100%', // 比页面还高
      borderRadius: 8,
      background: "#fff",
      boxShadow: "0 2px 8px rgba(0,0,0,0.08)",
      flexShrink: 0,
      overflowY: 'auto', // 添加滚动
    }}
  >
        {loading ? (
          <Spin tip="加载中..." style={{ width: "100%" }} />
        ) : (
          <TaskMenu 
          tasks={tasks}
          loading={loading}
          batchLoading={batchLoading}
          selectedTaskId={selectedTaskId}
          onTaskSelect={onTaskSelect}
          pageType={pageType}
          />
        )}
     </Sider>
);

export default SidebarMenu;